// import { WrappedPermissionDetailPage } from './lib/PermissionDetail';
import { WrappedPermissionDetailPage } from './lib/PermissionDetail2';

export * from './lib/components';
export default WrappedPermissionDetailPage;
